export default class Unit {
  constructor(
    _id,
    _unitNumber,
    _bedrooms,
    _isOccupied,
    _needsRepair,
    _ownerOccupied
  ) {
    this.id = _id;
    this.unitNumber = _unitNumber;
    this.bedrooms = _bedrooms;
    this.isOccupied = _isOccupied;
    this.needsRepair = _needsRepair;
    this.ownerOccupied = _ownerOccupied;
  }
}
